// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getShowWelcomePopup = (state: ApplicationState) => {
    return state.store.components.welcomePopup.showWelcomePopup;
};
